import { NisabCalculation, ZakatAsset, ZakatResult } from '../types';

const NISAB_WEIGHTS = {
  goldShSamer: 85,
  goldSubScholars: 87.48,
  goldShMazin: 100,
  silverShSamer: 595,
  silverSubScholars: 612.36,
  silverShMazin: 700,
};

export const calculateNisab = (
  goldPrice: number,
  silverPrice: number
): NisabCalculation => {
  return {
    goldShSamer: {
      weight: NISAB_WEIGHTS.goldShSamer,
      nisab: NISAB_WEIGHTS.goldShSamer * goldPrice,
    },
    goldSubScholars: {
      weight: NISAB_WEIGHTS.goldSubScholars,
      nisab: NISAB_WEIGHTS.goldSubScholars * goldPrice,
    },
    goldShMazin: {
      weight: NISAB_WEIGHTS.goldShMazin,
      nisab: NISAB_WEIGHTS.goldShMazin * goldPrice,
    },
    silverShSamer: {
      weight: NISAB_WEIGHTS.silverShSamer,
      nisab: NISAB_WEIGHTS.silverShSamer * silverPrice,
    },
    silverSubScholars: {
      weight: NISAB_WEIGHTS.silverSubScholars,
      nisab: NISAB_WEIGHTS.silverSubScholars * silverPrice,
    },
    silverShMazin: {
      weight: NISAB_WEIGHTS.silverShMazin,
      nisab: NISAB_WEIGHTS.silverShMazin * silverPrice,
    },
  };
};

export const calculateZakat = (
  nisabValue: number,
  goldPrice: number,
  silverPrice: number,
  asset: ZakatAsset
): ZakatResult => {
  const goldCashValue = asset.goldWeight * goldPrice;
  const silverCashValue = asset.silverWeight * silverPrice;
  const totalAssetValue =
    goldCashValue +
    silverCashValue +
    asset.cashValue +
    asset.stockValue -
    asset.deductibleDebt;

  const zakatOwed = totalAssetValue >= nisabValue ? (totalAssetValue * 2.5) / 100 : 0;

  return {
    goldCashValue,
    silverCashValue,
    totalAssetValue,
    zakatOwed,
  };
};

export const getNisabOptions = () => [
  { value: 'gold-sh-samer', label: 'Gold - Shaykh Samer Al-Nass' },
  { value: 'gold-subcon', label: 'Gold - Subcontinent Scholars' },
  { value: 'gold-sh-mazin', label: 'Gold - Shaykh Mazin Bakir' },
  { value: 'silver-sh-samer', label: 'Silver - Shaykh Samer Al-Nass' },
  { value: 'silver-subcon', label: 'Silver - Subcontinent Scholars' },
  { value: 'silver-sh-mazin', label: 'Silver - Shaykh Mazin Bakir' },
];

export const getNisabValue = (option: string, nisab: NisabCalculation): number => {
  const map: { [key: string]: number } = {
    'gold-sh-samer': nisab.goldShSamer.nisab,
    'gold-subcon': nisab.goldSubScholars.nisab,
    'gold-sh-mazin': nisab.goldShMazin.nisab,
    'silver-sh-samer': nisab.silverShSamer.nisab,
    'silver-subcon': nisab.silverSubScholars.nisab,
    'silver-sh-mazin': nisab.silverShMazin.nisab,
  };
  return map[option] || 0;
};
